import React, { createContext, useContext, useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import { useLocation } from "react-router-dom";
import { isTournamentUuid } from "../utility/tournamentUrls";

export const TournamentContext = createContext(null);

export const TournamentProvider = ({ children }) => {
  const [tournamentName, setTournamentName] = useState("");
  const [tournamentId, setTournamentId] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const fetchTournamentName = async (param) => {
      if (param) {
        try {
          const query = supabase.from("tournaments").select("id, name, slug");
          const { data, error } = isTournamentUuid(param)
            ? await query.eq("id", param).single()
            : await query.eq("slug", param).single();

          if (error) throw error;

          setTournamentId(data.id);
          setTournamentName(data.name);
        } catch (error) {
          console.error("Error fetching tournament name:", error);
        }
      }
    };

    // Extract tournament ID from URL path
    const match = location.pathname.match(/\/tournaments?\/([^\/]+)/);
    if (match) {
      const id = decodeURIComponent(match[1]);
      fetchTournamentName(id);
    }
  }, [location.pathname]);

  const updateTournament = (id, name) => {
    setTournamentId(id);
    setTournamentName(name);
  };

  return (
    <TournamentContext.Provider
      value={{ tournamentName, tournamentId, updateTournament }}
    >
      {children}
    </TournamentContext.Provider>
  );
};

export const useTournament = () => {
  const context = useContext(TournamentContext);
  if (!context) {
    throw new Error("useTournament must be used within a TournamentProvider");
  }
  return context;
};
